import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { VoucherProduct } from './VoucherProduct';
import { UserView } from './UserView';

export interface VoucherCodeRow {
  id: number;
  product_id: number;
  voucher_code: string;
  allocated_to_user_id: string;
}

export const VoucherCode: Entity<VoucherCodeRow> = {
  id: 'VoucherCode',
  title: 'Voucher Code',
  service: 'main',
  rowLabel: (row: VoucherCodeRow) => row.voucher_code,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.voucher_code',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  defaultSort: [['voucher_code', 'ASC']],
  defaultFilters: [{ fieldId: 'voucher_code', operator: 'sw', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
      visible: false,
    },
    product_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Product',
      listColumn: true,
      mandatory: true,
      refEntity: VoucherProduct,
    },
    voucher_code: {
      seq: 15,
      type: FieldType.Date,
      label: 'voucher_code',
    },
    allocated_to_user_id: {
      seq: 40,
      type: FieldType.Reference,
      label: 'Allocated To User',
      refEntity: UserView,
    },
  },
};
